import { createStyles } from "@mantine/core";

export const useStyles = createStyles(() => ({
  samplePhoto: {
    maxHeight: "100%",
    maxWidth: "100%",
  },
  samplePhotoContainer: {
    maxHeight: "90px",
    display: "flex",
    justifyContent: "center",
    marginRight: "8px",

    "&:last-child": {
      marginRight: "0",
    },
  },
  samplePhotosRow: {
    width: "100%",
  },
  explanationButton: {
    alignSelf: "flex-start",
  },
}));
